import script from "./MisconductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MisconductForm.vue?vue&type=script&setup=true&lang=js"

import "./MisconductForm.vue?vue&type=style&index=0&id=7a4f8294&scoped=true&lang=css"
import "./MisconductForm.vue?vue&type=style&index=1&id=7a4f8294&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4f8294"]])

export default __exports__